import http from 'axios'
import moment from 'moment'
import SmoothScroll from '#app#/global/smoothScroll.js'

export default {
    image(image, size = '0x0_ratio', name = null) {
        let source = '';
        if (image) {
            // return `/img/${image.id}/${size}/${name || image.localized.name}.${image.extension}`
            source = `/img/${image.hashId}/${size}/${name || image.localized.name}.${image.extension}`
        }

        return source;
    },

    tagged(items, tagValue, returnFirst = false) {
        let filteredItems = items.filter(item => {
            return item.tags.find(tag => tag.value == tagValue) || false;
        });

        return returnFirst ? filteredItems[0] || null : filteredItems;
    },

    trans(key) {
        let parts = key.split('.');
        let current = window.TRANSLATIONS;
        var translation = null;

        for (let index in parts) {
            let partKey = parts[index];
            if (typeof current[partKey] !== 'undefined') {
                current = current[partKey];
                translation = current;
            }
        }

        if (typeof translation === 'string') {
            return translation;
        } else {
            return key;
        }
    },

    stripTags(string) {
        const html = string;
        let div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    },

    scrollTo(target, duration = 300) {
        SmoothScroll(target, duration);
    },

    locale() {
        return document.querySelector('html').getAttribute('lang');
    },

    modal(caller, component) {
        caller.$emit('modal-open', component);
    },

    storage: {
        set(key, value) {
            localStorage.setItem(key, JSON.stringify(value));
        },

        get(key) {
            let value = localStorage.getItem(key) || null;
            return value ? JSON.parse(value) : null;
        },

        remove(key) {
            localStorage.removeItem(key);
        }
    },

    localizedDate(date, format = 'LL') {
        moment.locale(this.locale());
        return moment(date, 'YYYY-MM-DD').format(format);
    },

    localizedDateTime(datetime, format = 'LLL') {
        moment.locale(this.locale());
        return moment(datetime, 'YYYY-MM-DD HH:mm').format(format);
    }
}


// WEBPACK FOOTER //
// ../default-js/js/global/helpers.js